.root {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  text-align: center;
}

.sections {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.section {
  display: grid;
  gap: 8px;
  justify-items: center;
}

.section + .section {
  padding-top: 22px;
  border-top: 1px solid color-mix(in srgb, var(--line) 70%, transparent);
}

.title {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--accent);
}

.title::before,
.title::after {
  content: '';
  width: 18px;
  height: 1px;
  background: var(--accent-deep, var(--accent));
}

.lead {
  margin: 0;
  font-size: 17px;
  line-height: 1.4;
  color: var(--muted);
  text-wrap: balance;
}

.text {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: var(--muted);
}

.quote {
  margin: 0;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 19px;
  line-height: 1.45;
  color: var(--text);
}

.editable {
  width: 100%;
  display: grid;
  gap: 4px;
  justify-items: center;
}

.field {
  width: 100%;
  min-height: 1.4em;
  padding: 4px 8px;
  border-radius: 8px;
  outline: 1px dashed color-mix(in srgb, var(--accent) 45%, transparent);
  outline-offset: 2px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  cursor: text;
  transition: outline-color 0.15s ease, background-color 0.15s ease;
}

.field:focus {
  outline: 1px solid var(--accent);
  background: color-mix(in srgb, var(--accent) 6%, transparent);
}

.field:empty::before {
  content: attr(data-placeholder);
  color: var(--muted-dim, var(--muted));
  opacity: 0.7;
  pointer-events: none;
}

.counter {
  font-size: 11px;
  color: var(--muted);
}

.preview {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 20px 22px;
  border-radius: 20px;
  border: 1px solid var(--line);
  background: var(--surface);
  transition: border-color 0.15s ease;
}

.preview[data-editing] {
  border-color: color-mix(in srgb, var(--accent) 60%, transparent);
}

.bar {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
}

.barLabel {
  flex: 1;
  text-align: left;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--muted);
}

.badge {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 999px;
  color: var(--muted);
  box-shadow: inset 0 0 0 1px var(--line);
}

.badge[data-status='changed'] {
  color: var(--accent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--accent) 50%, transparent);
}

.pen {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  background: transparent;
  background-image: none;
  color: var(--accent);
  box-shadow: inset 0 0 0 1px var(--line);
}

.pen:hover {
  opacity: 1;
  box-shadow: inset 0 0 0 1px var(--accent);
}

.face {
  display: flex;
  justify-content: center;
}

.heading {
  display: grid;
  gap: 6px;
  justify-items: center;
  text-align: center;
}

.eyebrow {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--muted);
}

.name {
  margin: 0;
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 400;
  line-height: 1.05;
  color: var(--text);
}

.actions {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-top: 6px;
}

.reset {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.note {
  font-size: 13px;
  color: var(--muted);
}

.error {
  margin: 0;
  font-size: 13px;
  color: var(--danger);
}

@media (prefers-reduced-motion: reduce) {
  .field,
  .preview {
    transition: none;
  }
}
